
  import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
  import { Navigation, Pagination, Autoplay } from 'swiper'
  import 'swiper/swiper-bundle.css'

  SwiperCore.use([Navigation, Pagination, Autoplay])

  export default {
    name: 'ThemeStoresMobileIosScreenshots',
    components: { Swiper, SwiperSlide },
    data() {
      return {
        loadedScreenshots: {}
      }
    },
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      screenshotsWithLoading() {
        if (!this.pwa?.pwa_app_settings?.image_previews) return []
        const previewImages = this.pwa?.pwa_app_settings?.image_previews?.map(item => {
          return { src: `${this.$config.BUCKET_ROOT}/assets/banners/image_previews/${item}` }
        })
        return previewImages?.map((screenshot, index) => ({
          ...screenshot,
          loaded: this.loadedScreenshots[index] || false
        }))
      }
    },
    methods: {
      onImageLoad(index) {
        this.$set(this.loadedScreenshots, index, true)
      },
      onImageError(index) {
        this.$set(this.loadedScreenshots, index, false)
      }
    }
  }
